import { useDictionaryObject } from '../../../hooks/useDictionary/useDictionary';
import DumbDropdownAtom from './DropdownAtom.dumb';

/* ---------------------------------- Types --------------------------------- */

export interface DropdownAtomI {
    /** Indicates if an error exists for this field */
    hasError: boolean;

    /** Boolean as to whether the dropdown includes the filter functionality */
    canFilter?: boolean;

    /** Display label for the field */
    label: string;

    /** Array of options to choose from */
    options?: {
        value: string;
        label: string;
    }[];

    /** What to show when nothing is selected */
    placeholder: string;

    /** Whether the field is required to continue */
    required: boolean;

    /** Callback to trigger to update the value managed by the form */
    updateField: (value: string) => void;

    /** The current value of the field, managed by the form */
    value: string;

    /** Error message to be displayed below each field */
    errorText?: string;
}

/* -------------------------------- Component ------------------------------- */

const DropdownAtom = ({
    canFilter,
    errorText,
    hasError,
    label,
    options = [],
    placeholder,
    required,
    updateField,
    value,
}: DropdownAtomI) => {
    const optionsLabels = useDictionaryObject(
        options.reduce<Record<string, string>>(
            (sum, option) => ({
                ...sum,
                [option.value]: option.label,
            }),
            {},
        ),
    );

    const resolvedOptions = options.map((option) => ({
        ...option,
        label: optionsLabels[option.value] || option.label,
    }));

    return (
        <DumbDropdownAtom
            canFilter={canFilter}
            errorText={errorText}
            hasError={hasError}
            label={label}
            options={resolvedOptions}
            placeholder={placeholder}
            required={required}
            updateField={updateField}
            value={value}
        />
    );
};

/* --------------------------------- Export --------------------------------- */

export default DropdownAtom;
